<template>
    <el-popover
        :placement="placement||'bottom'"
        width="100"
        :value="visible"
    >
        <p style="text-align: center">{{content || '确定删除吗'}}？</p>
        <div style="text-align: right; margin: 0">
            <el-button size="mini" type="text" @click="visible=false">取消</el-button>
            <el-button
                :loading="loading"
                @click="handleConfirm(),visible=false"
                type="primary"
                size="mini">确定
            </el-button>
        </div>
        <span @click="visible=true" slot="reference"><slot></slot></span>
    </el-popover>
</template>

<script>
    export default {
        props: ['content', 'handleConfirm', 'loading', 'placement'],
        data () {
            return {
                visible: false,
            };
        },
        created() {
            this.visible = this.loading
        }
    };
</script>

<style lang="less" module>
</style>



// WEBPACK FOOTER //
// src/components/Common/Confirm.vue